angular
.module('resources.Image', ['ngResource'])
.factory('Album', ['$resource', function ($resource) {
  var Resource = $resource('/api/admin/images/:id', {id: '@_id'}, {
    query: {
      method: 'GET',
      isArray: false
    },
    update: {
      method: 'PUT'
    },
    create: {
      method: 'POST'
    },
    // search: {
    //   method: 'GET',
    //   url: '/api/admin/users-search',
    //   isArray: true
    // },
    getAll: {
      method: 'GET',
      url: '/api/admin/albums',
      isArray: false
    }
  });

  return Resource;
}]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Image.js